import { DomainAPI, Channel, getHeader } from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";

const serviceSetting = {
  state: {
    serviceSetting: {
      prefixItem: "",
      totalItem: 0,
      prefixEmployee: "",
      totalEmployee: 0,
      prefixCustomer: "",
      totalCustomer: 0,
      formatDatetime: "24h",
    },
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getServiceSetting(payload = {}, rootState) {
      const { adminService = {} } = rootState.service;
      if (adminService && adminService.no) {
        return dispatch.serviceSetting.getServiceSettingForAdmin({
          serviceCode: adminService.no,
        });
      } else {
        return fetch(
          DomainAPI + Channel + "/api/secure/serviceSettings/getServiceSetting",
          {
            method: "POST",
            headers: getHeader(true, rootState.user.token),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            checkResponse(result, dispatch);
            if (result.code === 1) {
              this.setState({ serviceSetting: result.data || {} });
            }
            return result;
          })
          .catch((err) => {
            return { code: 0, error: err, message: err.toString() };
          });
      }
    },
    getServiceSettingForAdmin(payload = {}, rootState) {
      return fetch(
        DomainAPI +
          Channel +
          `/api/secure/serviceSettings/getServiceSettingForAdmin?serviceCode=${payload.serviceCode}`,
        {
          method: "POST",
          headers: getHeader(true, rootState.user.token),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            this.setState({ serviceSetting: result.data || {} });
          }
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    updateServiceSetting(payload = {}, rootState) {
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/serviceSettings/updateServiceSetting",
        {
          method: "POST",
          headers: getHeader(true, rootState.user.token),
          body: JSON.stringify({
            ...payload.data,
            serviceCode: rootState.service.adminService
              ? rootState.service.adminService.no
              : null || null,
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            this.setState({ serviceSetting: result.data || {} });
          }
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  }),
};

export default serviceSetting;
